<template>
    <div class="column-sorting">
        <font-awesome-icon
            icon="caret-up"
            :class="{ active: isActive(1) }"
            class="up"
            @click="sort(1)"
        />

        <font-awesome-icon
            :class="{ active: isActive(-1) }"
            class="down"
            @click="sort(-1)"
            icon="caret-down"
        />
    </div>
</template>
<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ScheduledMajorOutage, GenericSort } from '@/utils/interfaces';

@Component({
})
export default class ColumnSortingComponent extends Vue {

    @Prop()
    private fields!: Array<keyof ScheduledMajorOutage>;

    @Prop()
    private activeSort!: GenericSort;

    private sort(direction: number): void {
        this.$emit('sort', this.fields, direction);
    }

    private isActive(direction: number): boolean {
        if (!this.activeSort)
            return false;

        if (this.fields.length !== this.activeSort.fields.length)
            return false;

        for (let i = 0; i < this.fields.length; i++) {
            if (this.fields[i] !== this.activeSort.fields[i])
                return false;
        }

        return direction === this.activeSort.direction;
    }
}
</script>
<style lang="less" >
.column-sorting{
    display: inline-block;
    margin: 6px;
    font-size: 1.5em;
}

.column-sorting .fa-icon{
    position: absolute;
    color: #545b62;
    cursor: pointer;
}

.column-sorting .fa-icon.up{
    top: -8px;
}

.column-sorting .fa-icon.down{
    top: 8px;
}

.column-sorting .fa-icon.active{
    color: white;
}

</style>
